// RHFTextArea.tsx
import { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
  Input,
  Label,
  FormGroup,
  FormFeedback,
  type InputProps,
} from "reactstrap";

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
  className?: string;
  rows?: number;
  required?: boolean;
} & Omit<InputProps, "name" | "type" | "invalid" | "id">;

const RHFTextArea = memo(function RHFTextArea({
  name,
  label,
  placeholder,
  className,
  rows = 3,
  required = false,
  ...rest
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormGroup className={className}>
          {label && <Label for={name}>{label}</Label>}
          {label && required && (
            <span
              className="ms-1 px-1 py-0 rounded-1 f-10 fw-bold"
              style={{
                background: "#FEE2E2",
                color: "#B91C1C",
                verticalAlign: "middle",
              }}
            >
              required
            </span>
          )}
          <Input
            id={name}
            type="textarea"
            placeholder={placeholder}
            rows={rows}
            invalid={!!fieldState.error}
            {...field} // contains value, onChange, onBlur
            {...rest}
          />
          {fieldState.error && (
            <FormFeedback>{fieldState.error.message}</FormFeedback>
          )}
        </FormGroup>
      )}
    />
  );
});

export default RHFTextArea;
